import { UiButton, SideImageCard } from "@/components";
import { Head } from "@/components/seo";
import { useEnrolement } from "@/composables/enrolement";
import { ArrowLeft } from "lucide-react";
import { useParams, useNavigate } from "react-router-dom";
import { useEffect } from "react";
import CheckAnimalResult from "@/components/molecules/enrolement/check.animal.result";
import { useEnrolementStore } from "@/context/stores/enrolement.store";

export default function PublicEnrolementsPage() {
  const navigate = useNavigate();
  const { matricule } = useParams<{ matricule: string }>();
  const { loading, checkAnimal } = useEnrolement();
  const enrol = useEnrolementStore((state) => state.enrol);

  useEffect(() => {
    if (matricule) {
      checkAnimal(matricule);
    }
  }, [matricule]);

  return (
    <>
      <Head title="Enrolements | Jourgui" />

      <div className="container mx-auto py-4">
        <SideImageCard
          loading={loading}
          imgSrc="/assets/images/chris-lee-70l1tDAI6rM-unsplash 1.png"
        >
          <div>
            <UiButton
              variant="text"
              onClick={() => navigate(-1)}
              startIcon={<ArrowLeft />}
            >
              Retour
            </UiButton>
          </div>

          <div className=" p-4 w-full">
            <CheckAnimalResult
              matricule={matricule ?? ""}
              loading={loading}
              enrol={enrol}
            />
          </div>
        </SideImageCard>
      </div>
    </>
  );
}
